module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0741b_banner_800x600.8590afeb.png";